import { render, staticRenderFns } from "./AdUnitSettingsHeader.vue?vue&type=template&id=bc105c48&shadow"
import script from "./AdUnitSettingsHeader.vue?vue&type=script&lang=js&shadow"
export * from "./AdUnitSettingsHeader.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports